import React from "react";

const StepContainer = ({
  currentStep,
  totalSteps,
  title,
  subtitle,
  children,
  onSubmit,
  onBack,
  buttonText = "Continuar",
  buttonClass = "btn-sirio",
  isValid = true,
}) => {
  return (
    <div className="login-content" style={{ width: "100%", maxWidth: "100%" }}>
      <div className="text-center mb-5">
        <p
          className="mb-2"
          style={{
            // color: "rgb(74, 101, 2)",
            color: "#4a6502",
            letterSpacing: "1px",
            fontSize: "0.8rem",
            fontWeight: "bold"
          }}
        >
          PASO {String(currentStep).padStart(2, "0")} DE{" "}
          {String(totalSteps).padStart(2, "0")}
        </p>
        <h1 className="fw-bolder" style={{ color: "#162b4d" }}>
          {title}
        </h1>
        <p
          className="text-muted fs-5"
          style={{ fontSize: '0.9rem'}}
        >{subtitle}</p>
      </div>

      <form id="frmRegister" className="margin-bottom-0" onSubmit={onSubmit}>
        {children}

        <div className="login-buttons mt-5 mb-3 d-flex align-items-center justify-content-between">
          {currentStep > 1 ? (
            <button
              type="button"
              onClick={onBack}
              className="btn d-flex align-items-center justify-content-center"
              style={{ borderRadius: "10px", backgroundColor: "#fff", border: "1px solid #6c757d", color: "#6c757d", padding: "14px 24px", fontSize: "1rem", lineHeight: "1.5" }}
            >
              <span style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
                <i className="fa fa-chevron-left" style={{ fontSize: "0.9rem", color: "inherit" }}></i>
                <span>Volver</span>
              </span>
            </button>
          ) : (
            <div />
          )}

          {currentStep === totalSteps ? (
            <a
              href="/user/login-v3"
              className="btn fw-bold text-white d-flex align-items-center justify-content-center"
              style={{ backgroundColor: "#4a6502", borderRadius: "10px", padding: "14px 24px", fontSize: "1rem", lineHeight: "1.5", textDecoration: "none" }}
            >
              <span style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
                <span>Iniciar sesión</span>
                <i className="fa fa-arrow-right" style={{ fontSize: "0.9rem", color: "inherit" }}></i>
              </span>
            </a>
          ) : (
            <button
              type="submit"
              className={`btn ${buttonClass} d-flex align-items-center justify-content-center`}
              style={{ borderRadius: "10px", padding: "14px 24px", fontSize: "1rem", lineHeight: "1.5", opacity: isValid ? 1 : 0.5 }}
              disabled={!isValid}
            >
              <span style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
                <span>{buttonText}</span>
                {buttonText === "Continuar" && <i className="fa fa-chevron-right" style={{ fontSize: "0.9rem", color: "inherit" }}></i>}
                {buttonText === "Finalizar" && <i className="fa fa-check" style={{ fontSize: "0.9rem", color: "inherit" }}></i>}
              </span>
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default StepContainer;
